import { render, staticRenderFns } from "./ReportsFilters.vue?vue&type=template&id=23a356d1&"
import script from "./ReportsFilters.vue?vue&type=script&lang=ts&"
export * from "./ReportsFilters.vue?vue&type=script&lang=ts&"
import style0 from "./ReportsFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports